// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

const pkg = require('../package.json');

const DATA_URL = 'https://ix.cnn.io/data/ice-tracker/trac_detainees_criminality.json';

// Cache for fetched data
let cachedData = null;
let cachedJson = null;

async function fetchData() {
  if (cachedData) return cachedData;
  const response = await fetch(DATA_URL);
  const text = await response.text();
  // Replace NaN with null to make valid JSON
  const sanitized = text.replace(/:\s*NaN/g, ': null');
  const json = JSON.parse(sanitized);

  // Store full JSON for access to top-level fields
  cachedJson = json;

  cachedData = json.data.filter(d => d.criminality !== 'all'
    && d.authority !== 'cbp'
    && d.authority !== 'total'
    && d.detainees != null
    && d.detainees > 0);
  return cachedData;
}

function formatSignificant(num, digits = 3) {
  return Number(num).toPrecision(digits);
}

function generateSubhed(data) {
  const noncriminalPct = formatSignificant(data.iceNoncriminalPct, 2);
  const nonconvictPct = formatSignificant(data.iceNonconvictPct, 2);
  const convictPct = formatSignificant(data.iceConvictPct, 2);

  return `In past administrations, detainees arrested by ICE were primarily individuals with criminal convictions. The latest numbers show ${convictPct}% of detainees have a prior criminal conviction, while ${nonconvictPct}% have only an immigration violation or criminal charges that remain pending.
<br><br><b>Detainees with:</b><br>
<b class="subhed-swatch" style="background:#92b0aa; color:white; padding:1px 2px;">Criminal convictions</b><br>
<b class="subhed-swatch" style="background:#53A796; color:white; padding:1px 3px;">Pending criminal charges</b><br>
<b class="subhed-swatch" style="background:#07473A; color:white; padding:1px 3px;">Other immigration violations</b> (no criminal charges)`;
}

function generateFootnote(data) {
  return `Data last updated ${data.lastUpdatedStr}.`;
}

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw, id: pkg.name });

window.onload = async () => {
  await fetchData();

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);
      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  // Generate dynamic content from fetched data (runs in ALL environments)
  if (cachedJson) {
    const subhedNode = document.querySelector('.subhed');
    if (subhedNode) subhedNode.innerHTML = generateSubhed(cachedJson);

    const footnoteNode = document.querySelector('.footnote');
    if (footnoteNode) footnoteNode.innerHTML = generateFootnote(cachedJson);
  }

  const { pymChild } = window;
  pymChild.sendHeight();
};

async function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const raw = await fetchData();
  const props = {
    initialWidth: safeWidth, initialHeight, isMobile, raw,
  };

  const graphicConfig = config(props);
  graphic(graphicConfig, container, isMobile);

  // Send height after graphic is rendered
  window.pymChild.sendHeight();
}
